import { render, staticRenderFns } from "./BussinessList.vue?vue&type=template&id=7afe8456&"
import script from "./BussinessList.vue?vue&type=script&lang=js&"
export * from "./BussinessList.vue?vue&type=script&lang=js&"
import style0 from "./BussinessList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports